<template>
  <v-card flat>
    <v-menu
      bottom
      offset-y
      nudge-bottom="5"
      v-model="actionType"
      max-height="500"
      :disabled="count <= 0 && valueComputed === 'all'"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-on="on" v-bind="attrs" v-if="typeContent">
          <v-icon left small>mdi-{{ typeContent.icon }}</v-icon>
          {{ typeContent.name }}
          <v-fade-transition mode="out-in">
            <v-icon class="ms-2" key="down" v-if="!actionType"
              >mdi-chevron-down</v-icon
            >
            <v-icon class="ms-2" key="up" v-else>mdi-chevron-up</v-icon>
          </v-fade-transition>
        </v-btn>
      </template>

      <v-list dense>
        <template v-for="(item, i) in itemsType">
          <v-list-item
            :key="i"
            color="primary"
            @click="valueComputed = item.value"
            v-if="item.value.toLowerCase() !== valueComputed.toLowerCase()"
          >
            <v-list-item-icon>
              <v-icon>mdi-{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TypeMenu",

  props: {
    value: String,
    count: Number,
  },

  data: () => ({
    actionType: false,
    itemsType: [],
  }),

  mounted() {
    this.itemsType[0] = { name: "مدل کیوآر", value: "all", icon: "filter" };
    this.itemsType = this.itemsType.concat(this.getQrTypes());
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.updateTypeFilter(val);
        // this.$emit('input', val)
      },
    },
    typeContent() {
      return this.itemsType.find(
        (item) => item.value.toLowerCase() === this.valueComputed.toLowerCase()
      );
    },
  },

  methods: {
    ...mapActions("localstorage", ["updateTypeFilter"]),
  },
};
</script>

<style scoped></style>
